// extracted by css-extract-rspack-plugin
var _1 = "j9N72c7Ljqgey3kT";
var _2 = "xMRC4Fj_hodMtlaC";
var _3 = "ZLWv9s_FH0I5X4rj";
var _4 = "_MAj3g038u8nVQWE";
var _5 = "MOUb_6KjIZzGYlaE";
var _6 = "Y0VIyd6gGsICCZg9";
var _7 = "I69z6XTI8bYkOPJT";
var _8 = "hRqQjOTmK6kGz2PH";
var _9 = "kZw8219Xc_gQwOFA";
var _a = "j9N72c7Ljqgey3kT";
var _b = "xMRC4Fj_hodMtlaC";
var _c = "ZLWv9s_FH0I5X4rj";
var _d = "_MAj3g038u8nVQWE";
var _e = "MOUb_6KjIZzGYlaE";
var _f = "Y0VIyd6gGsICCZg9";
var _10 = "I69z6XTI8bYkOPJT";
var _11 = "hRqQjOTmK6kGz2PH";
var _12 = "kZw8219Xc_gQwOFA";
export { _1 as "ts-card--medium", _2 as "ts-card--squared", _3 as "ts-position", _4 as "ts-position__goal", _5 as "ts-position__pitch", _6 as "ts-position__stats", _7 as "ts-position__title", _8 as "ts-rank", _9 as "ts-rank__label", _a as "tsCardMedium", _b as "tsCardSquared", _c as "tsPosition", _d as "tsPositionGoal", _e as "tsPositionPitch", _f as "tsPositionStats", _10 as "tsPositionTitle", _11 as "tsRank", _12 as "tsRankLabel" }
